import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
 import { cookieHelper } from "@/common/CookieHelper";
const app = createApp(App).use(ElementPlus).use(router);
// createApp(App).use(ElementPlus).use(router).mount('#app')
// 全局路由守卫
// router.beforeEach(async (to:any, from:any, next:any) => {
//   // 设置页面标题
// //   document.title = to.meta.title ? `${to.meta.title} - 我的应用` : '我的应用'
  
//   // 获取登录状态（可以从 Pinia、Vuex、localStorage 获取）
//   const token = cookieHelper.getCookie("token");
//  // const token = localStorage.getItem('token')
//   const isLoggedIn = !!token
  
//   // 需要登录的页面
//   if (to.meta.requiresAuth && !isLoggedIn) {
   
//     // 跳转到登录页，并保存原目标路径
//     next({
//       path: '/login',
//       query: { redirect: to.fullPath }
//     })
//   } 
//   // 已登录用户访问登录页，直接跳转到首页
//   else if (to.path === '/login' && isLoggedIn) {
//     next('/')
//   }
//   else {
//     next()
//   }
// }) 
app.mount('#app');